import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePlayerSettings = defineStore('playerSettings', () => {
  const sound = ref(true)
  const betLevels = ref([33, 50, 75, 100])
  const displayMode = ref<'bb' | 'chips'>('bb')

  const nickname = ref<string | null>(null)
  const avatarId = ref<string | null>(null)

  return {
    sound,
    betLevels,
    displayMode,

    nickname,
    avatarId
  }
})
